(function () {
  function slugifyHeading(text) {
    return (text || '')
      .trim()
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  function uniqueId(baseId, usedIds, fallbackIndex) {
    var id = baseId || 'section-' + fallbackIndex;
    var suffix = 2;
    while (usedIds[id]) {
      id = (baseId || 'section') + '-' + suffix;
      suffix += 1;
    }
    usedIds[id] = true;
    return id;
  }

  function appendTocLink(list, usedIds, label, scrollTarget, fallbackIndex) {
    if (!label || !scrollTarget) return;

    var id = scrollTarget.id;
    if (!id) {
      id = uniqueId(slugifyHeading(label), usedIds, fallbackIndex);
      scrollTarget.id = id;
    } else {
      usedIds[id] = true;
    }

    var item = document.createElement('li');
    var link = document.createElement('a');
    link.setAttribute('href', '#' + id);
    link.textContent = label;
    item.appendChild(link);
    list.appendChild(item);
  }

  function buildTocFromArticleHeadings(root) {
    var listHost = root.querySelector('[data-iw-blog-toc-from-content]');
    var articleContent = root.querySelector('[data-iw-blog-article-content]');
    var nav = root.querySelector('[data-iw-blog-details-toc]');
    if (!listHost) return;

    var headings = articleContent
      ? Array.prototype.slice.call(articleContent.querySelectorAll('h2'))
      : [];
    var faqSection = root.querySelector('.iw-blog-details-faq');
    var faqHeading = faqSection
      ? faqSection.querySelector(':scope > h2.iw-blog-details-heading')
      : null;

    if (!headings.length && !faqHeading) {
      listHost.innerHTML = '';
      if (nav) {
        nav.hidden = true;
      }
      return;
    }

    if (nav) {
      nav.hidden = false;
    }

    var usedIds = Object.create(null);
    var list = document.createElement('ul');
    var itemIndex = 0;

    headings.forEach(function (heading) {
      var label = (heading.textContent || '').trim();
      if (!label) return;

      itemIndex += 1;
      appendTocLink(list, usedIds, label, heading, itemIndex);
    });

    if (faqHeading) {
      var faqLabel = (faqHeading.textContent || '').trim();
      if (faqLabel) {
        itemIndex += 1;
        var faqTarget = faqSection;
        if (!faqTarget.id) {
          faqTarget.id = uniqueId(slugifyHeading(faqLabel) || 'faq', usedIds, itemIndex);
        }
        appendTocLink(list, usedIds, faqLabel, faqTarget, itemIndex);
      }
    }

    listHost.innerHTML = '';
    listHost.appendChild(list);
  }

  function initToc(root) {
    buildTocFromArticleHeadings(root);

    var nav = root.querySelector('[data-iw-blog-details-toc]');
    if (!nav) return;

    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    if (!links.length) return;

    links.forEach(function (link) {
      link.classList.add('iw-blog-details-toc__link');
    });

    var targets = links
      .map(function (link) {
        var id = (link.getAttribute('href') || '').slice(1);
        if (!id) return null;
        var el = document.getElementById(id);
        return el ? { link: link, el: el, id: id } : null;
      })
      .filter(Boolean);

    if (!targets.length) return;

    var ticking = false;
    var urlUpdatesEnabled = false;

    function getOffset() {
      var headerHeight =
        parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--header-height')
        ) || 80;

      return headerHeight + 24;
    }

    function setActive(id, updateUrl) {
      links.forEach(function (link) {
        var isActive = link.getAttribute('href') === '#' + id;

        link.classList.toggle('is-active', isActive);

        if (isActive) {
          link.setAttribute('aria-current', 'location');
        } else {
          link.removeAttribute('aria-current');
        }
      });

      if (updateUrl && id && window.location.hash !== '#' + id) {
        history.replaceState(null, '', '#' + id);
      }
    }

    function getActiveIdFromScroll() {
      var offset = getOffset();
      var activeId = null;

      for (var i = 0; i < targets.length; i++) {
        if (targets[i].el.getBoundingClientRect().top <= offset) {
          activeId = targets[i].id;
        } else {
          break;
        }
      }

      return activeId;
    }

    function syncFromScroll(updateUrl) {
      var activeId = getActiveIdFromScroll();

      if (activeId) {
        setActive(activeId, !!updateUrl);
      }

      ticking = false;
    }

    function onScroll() {
      if (!urlUpdatesEnabled) {
        urlUpdatesEnabled = true;
      }

      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        syncFromScroll(true);
      });
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;

        var id = href.slice(1);
        var target = document.getElementById(id);
        if (!target) return;

        event.preventDefault();
        urlUpdatesEnabled = true;
        setActive(id, true);

        window.scrollTo({
          top: target.getBoundingClientRect().top + window.pageYOffset - getOffset(),
          behavior: 'smooth',
        });
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });

    window.addEventListener('hashchange', function () {
      var hash = window.location.hash.replace('#', '');
      if (hash) {
        setActive(hash, false);
      }
    });

    var initial = window.location.hash.replace('#', '');

    if (initial && document.getElementById(initial)) {
      // Hash already in URL from a shared/deep link — keep it, don't rewrite on load.
      setActive(initial, false);
      window.scrollTo({
        top:
          document.getElementById(initial).getBoundingClientRect().top +
          window.pageYOffset -
          getOffset(),
      });
    } else {
      // First load with no hash: highlight if a section is in view, but do not write URL yet.
      syncFromScroll(false);
    }
  }

  function boot() {
    document.querySelectorAll('.iw-blog-post-content').forEach(initToc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector) return;

    var root = event.target.querySelector('.iw-blog-post-content');

    if (root) {
      initToc(root);
    }
  });
})();
